import axios from '@/config/axios'


const urlDefault = '/v1/api/mg/banner'

/**
 * 获取轮播图列表
 */
export const banners = (query) => axios.get(urlDefault, {params: query})


/**
 * 更新
 * @param banner 轮播图
 * @returns {IDBRequest | Promise<void>}
 */
export const createBanner = (banner) => axios.post(urlDefault, banner)


export const deleteBanner = (id) => axios.delete(`${urlDefault}/${id}`)
